import React, { Component } from 'react'

import Aux from '../../../hoc/ReactAux/ReactAux'
import ReactModal from 'react-modal'
import ErrorReference from '../ErrorReference'
import { toDisplayError } from '../../../utils/userError'
import './modalError.scss'

const customStyles = {
  content: {
    background: 'none',
    border: 'none',
  },
  overlay: {
    zIndex: '9999999',
    width: '100%',
    height: '100%',
    left: '0',
    top: '0',
    backgroundColor: 'rgba(0, 0, 0, 0.7)'
  }
}

// Every error popup: what failed, why (when known), what to do next, and a reference line
// support can use (docs/ERROR_MESSAGES.md). errorMessage is a userError / mapCheckoutError
// result; a plain string is shown as the body under a title built from area/task/title props.
class ModalError extends Component {
  displayFor(value) {
    // The same error keeps the same reference time across re-renders.
    if (!this.cached || this.cached.value !== value) {
      this.cached = {
        value,
        display: toDisplayError(value, {
          area: this.props.area,
          task: this.props.task,
          title: this.props.title,
          code: this.props.errorCode,
        }),
      }
    }
    return this.cached.display
  }

  render() {

    if (!this.props.showModal) {
      return null
    }

    const error = this.displayFor(this.props.errorMessage)
    const { title, message, guidance, orderNumber } = error

    return (
      <Aux>
        <ReactModal
          isOpen={this.props.showModal}
          style={customStyles}
          onRequestClose={this.props.closeModal}
          shouldCloseOnOverlayClick={true}
          shouldCloseOnEsc={true}
          role="alertdialog"
          aria={{ describedby: 'checkout-error-description', labelledby: 'checkout-error-title' }}
          contentLabel={title}>
          <div style={this.props.style} id="lb-error" className="lb-geral lb-error_ mfp-bg-login error-popup-block  lb-centralizar singup zoom-anim-dialog">
            <div className="lb-padrao-singup6 mfp-content-login modal-content">
              <button type="button" onClick={this.props.closeModal} className="bt-close mfp-close lb-fechar fa fa-times" aria-label="Close error message" />
              <div className="check-mark">
                <span className="fa fa-exclamation-circle lt-error-icon" aria-hidden="true" />
              </div>
              <div style={this.props.styleContent} className="lb-content">
                <div className="order lt-modal-error__body" id="checkout-error-description">
                  <strong id="checkout-error-title" className="lt-modal-error__title">{title}</strong>
                  {message ? <p className="lt-modal-error__message">{message}</p> : null}
                  {guidance ? <p className="lt-modal-error__guidance">{guidance}</p> : null}
                  {orderNumber ? <p className="lt-modal-error__order"><strong>Order number:</strong> {orderNumber}</p> : null}
                  <ErrorReference error={error} showContact onContactSupport={this.props.closeModal} />
                </div>
                {!!this.props.actionButton ?
                  (
                    <button type="button" onClick={this.props.actionButton} className="bt">
                      {this.props.actionButtonTitle}
                    </button>
                  ) : (
                    <button type="button" onClick={this.props.closeModal} className="bt">
                      Close
                    </button>
                  )
                }
              </div>
            </div>
          </div>
        </ReactModal>
      </Aux>
    )
  }
}



export default ModalError



// WEBPACK FOOTER //
// ./src/components/UI/Modal/ModalError.js